import { AlertFactory } from 'alerts/Alert'
import ModalViewModel from 'infra/ModalViewModel'
import Job from 'jobs/Job'
import JobStore from 'jobs/JobStore'
import { task } from 'mobx-task'

export default class BookkeepingCompleteJobDialogViewModel extends ModalViewModel {
  constructor(
    private jobStore: JobStore,
    private job: Job,
    private newAlert: AlertFactory,
  ) {
    super()
  }

  /**
   * Completes the job
   */
  submit = task.resolved(async () => {
    try {
      await this.jobStore.close(this.job)
      this.close()
    } catch (error) {
      this.newAlert().fromError(error).show()
      console.error(error)
    }
  })
}
